// eslint-disable-next-line import/prefer-default-export
export const cleanReprName = (name) => name.replace(/\s|君|\[(.*?)\]/g, '');
